export const EDIT_COMPANY_GENERAL_INFO_MODAL = 'edit_company_general_info_modal'
export const EDIT_COMPANY_ADDRESS_MODAL = 'edit_company_address_modal'
export const EDIT_DMT_FEE_MODAL = 'edit_dmt_fee_modal'
export const EDIT_PRICE_WEIGHT = 'EDIT_PRICE_WEIGHT'
export const EDIT_PRICE_MODAL = 'EDIT_PRICE_MODAL'
export const ATTACH_SOURCE_FILE_MODAL = 'ATTACH_SOURCE_FILE_MODAL'
export const FIX_ERRORS_MODAL = 'FIX_ERRORS_MODAL'
export const LABEL_ERRORS_MODAL = 'LABEL_ERRORS_MODAL'
export const CREATE_ASSIGNMENT_SOURCE_FILE_ERRORS = 'CREATE_ASSIGNMENT_SOURCE_FILE_ERRORS'
export const CARRIER_PRIORITY_MODAL = 'CARRIER_PRIORITY_MODAL'
export const DOWNLOAD_LABELS = 'DOWNLOAD_LABELS'
export const DOWNLOAD_LABELS_WARNING = 'DOWNLOAD_LABELS_WARNING'
export const CREATE_NEW_CUSTOMER = 'CREATE_NEW_CUSTOMER'
export const CREATE_PACKING_SLIP = 'CREATE_PACKING_SLIP'
export const PACKING_SLIPS = 'PACKING_SLIPS'
export const PACKING_SLIP = 'PACKING_SLIP'
export const PACKING_SLIP_PREVIEW = 'PACKING_SLIP_PREVIEW'
export const PACKING_SLIP_EDIT = 'PACKING_SLIP_EDIT'
export const SENDER_ADDRESSES = 'SENDER_ADDRESSES'
export const SENDER_ADDRESS_ACTION = 'SENDER_ADDRESS_ACTION'
export const INTEGRATIONS = 'INTEGRATIONS'
export const INTEGRATION_DETAILS = 'INTEGRATION_DETAILS'
export const INTEGRATION_ORDERS = 'INTEGRATION_ORDERS'
export const WOO_COMMERCE_KEYS = 'WOO_COMMERCE_KEYS'
export const MAGENTO_KEYS = 'MAGENTO_KEYS'
export const SHOPIFY_WEBHOOK_SETTINGS = 'SHOPIFY_WEBHOOK_SETTINGS'
export const ONGOING_WEBHOOK_SETTINGS = 'ONGOING_WEBHOOK_SETTINGS'
export const VISKAN_SETTINGS = 'VISKAN_SETTINGS'
export const REQUEST_ERROR = 'REQUEST_ERROR'
export const CONFIRM_REPORT = 'CONFIRM_REPORT'
export const USERS = 'USERS'
export const USERS_CREATE_EDIT = 'USERS_CREATE_EDIT'
export const STAFF_USER_CREATE = 'STAFF_USER_CREATE'
export const STAFF_USER_EDIT = 'STAFF_USER_EDIT'
export const ASSIGNMENT_STATUS_MODAL = 'ASSIGNMENT_STATUS_MODAL'
export const ASSIGNMENT_HISTORY_MODAL = 'ASSIGNMENT_HISTORY_MODAL'
export const ASSIGNMENT_INTEGRATION_MODAL = 'ASSIGNMENT_INTEGRATION_MODAL'
export const ITEM_HISTORY_MODAL = 'ITEM_HISTORY_MODAL'
export const ITEM_INTEGRATION_MODAL = 'ITEM_INTEGRATION_MODAL'
export const REPORT_SUBSCRIPTION_ACTION = 'REPORT_SUBSCRIPTION_ACTION'
export const CREATE_INVENTORY_PRODUCT = 'CREATE_INVENTORY_PRODUCT'
export const REGISTER_INVENTORY_INBOUND_DELIVERY = 'REGISTER_INVENTORY_INBOUND_DELIVERY'
export const EDIT_COMPANY_TAX_NUMBERS_MODAL = 'edit_company_tax_numbers_modal'
export const ADDRESS_BOOK_FORM = 'ADDRESS_BOOK_FORM'
export const ADDRESS_BOOK_PICKER = 'ADDRESS_BOOK_PICKER'
export const ADDRESS_BOOK_IMPORT = 'ADDRESS_BOOK_IMPORT'
export const DISTRIBUTION_CHANNELS_MODAL = 'DISTRIBUTION_CHANNELS_MODAL'
